import { render, staticRenderFns } from "./pic_role_mapping.vue?vue&type=template&id=a4e181fc&"
import script from "./pic_role_mapping.vue?vue&type=script&lang=js&"
export * from "./pic_role_mapping.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports